module.exports = __webpack_public_path__ + "Observation.jpg?35cdfceb57b861d42b5aaa13c2d74b05";


//////////////////
// WEBPACK FOOTER
// ./static/Observation.jpg
// module id = 91
// module chunks = 0